module.exports = __webpack_public_path__ + "img/file-lines-solid.6e0bce81.svg";